(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignInviteDetailsEditController', Controller);

    Controller.$inject = ['$scope', '$stateParams', '$state', 'modalService', 'businessUnit', 'externalParty', 'campaign'];

    function Controller($scope, $stateParams, $state, modalService, businessUnit, externalParty, campaign) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;
        $scope.businessUnit = businessUnit;

        if (_.isObject(campaign) && _.size(campaign.ODDInviteDetails) > 0) {
            $scope.inviteDetails = campaign.ODDInviteDetails[0];
        }

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit', null, {reload: true});
        };

        $scope.goToCampaign = function (campaign) {
            $state.go('odd.externalPartyEdit.campaign', {
                ODDExternalPartyID: campaign.ODDExternalPartyID,
                ODDCampaignID: campaign.ODDCampaignID
            })
        };
    }
})();